import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'gen-notes-modal-wrapper',
  templateUrl: './notes-modal-wrapper.component.html',
  styleUrls: ['./notes-modal-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotesModalWrapperComponent implements OnInit {

  public payload: {
    actorType: any,
    contextType: string,
    newNotes: any,
    actorId: any,
    contextId: any,
    filters: boolean,
    classes: string,
    readOnly: boolean,
    nonAberation:boolean,
    queryType:string
  };
  public tunnel$: Subject<any>;
  public callback: (newNote: any) => void;
  constructor() { }

  ngOnInit() {
  }

  noteAddedEmit(data) {
    this.callback(data);
  }

}
